import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  xs12: "",
  class: "container-full"
}
const _hoisted_2 = {
  key: 0,
  class: "slide-bar"
}
const _hoisted_3 = { xs3: "" }
const _hoisted_4 = {
  xs9: "",
  class: "ps-1 pe-1"
}
const _hoisted_5 = {
  key: 1,
  class: "row mx-0 slide-bar"
}
const _hoisted_6 = {
  md4: "",
  xs12: ""
}
const _hoisted_7 = { class: "title m-0" }
const _hoisted_8 = {
  md8: "",
  xs12: "",
  class: "mt-2"
}

import { ref, watch, reactive, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SlideBar',
  props: {
    current: { default: 0 },
    total: { default: 0 },
    slideColor: { default: '#7DD420' },
    bgColor: { default: '#e6e6e6' },
    slideType: { default: 'row' },
    maxSize: { default: '' },
    align: { default: '' }
  },
  setup(__props: any) {

const props = __props

const styles = ref<Record<string, string>>({})
const stylesBg = ref<Record<string, string>>({})

const watchChange = () => {
  styles.value = {
    width: (props.current * 100) / props.total + '%',
    'background-color': props.slideColor
  }
}

watch(() => props.current, watchChange)
watch(() => props.total, watchChange)

onMounted(() => {
  watchChange()
  stylesBg.value = {
    'background-color': props.bgColor
  }
  if (props.maxSize) {
    stylesBg.value = {
      'background-color': props.bgColor,
      'max-width': props.maxSize
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.slideType === 'row')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'text-sm-start': __props.align == 'left', 'text-xs-right': __props.align == 'right' })
            }, _toDisplayString(__props.current) + " of " + _toDisplayString(__props.total), 3 /* TEXT, CLASS */)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "slide-bar-bgr",
              style: _normalizeStyle(stylesBg.value)
            }, [
              _createElementVNode("div", {
                class: "slide-bar-progress",
                style: _normalizeStyle(styles.value)
              }, null, 4 /* STYLE */)
            ], 4 /* STYLE */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.slideType === 'col')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(_toDisplayString(__props.current), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "small-text" }, "%", -1 /* CACHED */))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "slide-bar-bgr float-left",
              style: _normalizeStyle(stylesBg.value)
            }, [
              _createElementVNode("div", {
                class: "slide-bar-progress",
                style: _normalizeStyle(styles.value)
              }, null, 4 /* STYLE */)
            ], 4 /* STYLE */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})